import { ImageAnnotations } from './DatasetsDetailsImagesSliderTypes';

interface DatasetsDetailsImagesSlider2DBoxesOverlayProps {
  data: ImageAnnotations[];
  color: string;
  strokeWidth: number;
}

export const DatasetsDetailsImagesSlider2DBoxesOverlay = ({
  data,
  color,
  strokeWidth,
}: DatasetsDetailsImagesSlider2DBoxesOverlayProps) => {
  return (
    <>
      {data?.map(({ id, bbox }, index) => {
        if (!bbox) {
          return null;
        }
        return (
          <rect
            key={id || index}
            width={bbox[2]}
            height={bbox[3]}
            x={bbox[0]}
            y={bbox[1]}
            style={{
              fill: 'none',
              strokeWidth,
              stroke: color,
            }}
          />
        );
      })}
      Sorry, your browser does not support inline SVG.
    </>
  );
};
